import { SERVICES } from "@/content";
import { Reveal } from "@/components/landing/Reveal";

const ServiceCard = ({ service, span }) => {
  const Icon = service.icon;
  return (
    <article
      data-testid={`service-card-${service.id}`}
      className={`group relative flex min-h-[16rem] flex-col justify-between overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] p-8 transition-[border-color,background-color] duration-500 hover:border-white/30 hover:bg-white/[0.04] ${span}`}
    >
      <div className="flex items-center justify-between">
        <span className="font-mono text-xs tracking-[0.3em] text-zinc-500">{service.index}</span>
        <Icon className="h-5 w-5 text-zinc-500 transition-colors duration-500 group-hover:text-white" />
      </div>
      <div className="mt-12">
        <h3 className="font-display text-xl font-bold uppercase tracking-tight sm:text-2xl">
          {service.title}
        </h3>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-400">{service.description}</p>
      </div>
    </article>
  );
};

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative scroll-mt-28 border-t border-white/10 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-400">What we do</p>
        <h2 className="mt-4 max-w-3xl font-display text-2xl font-bold uppercase tracking-tight sm:text-4xl lg:text-5xl">
          Every desire. <span className="text-zinc-500">One company.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-zinc-400 sm:text-base">
          Desires After Hours provides entertainment and creative solutions
          across various domains, offering platforms with millions of views for
          creators to showcase their work. It also includes a service menu,
          content homes, digital courses for online businesses, websites, and more.
        </p>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-12">
        <Reveal className="md:col-span-7" delay={0.05}>
          <ServiceCard service={SERVICES[0]} span="h-full" />
        </Reveal>
        <Reveal className="md:col-span-5" delay={0.15}>
          <ServiceCard service={SERVICES[1]} span="h-full" />
        </Reveal>
        <Reveal className="md:col-span-5" delay={0.05}>
          <ServiceCard service={SERVICES[2]} span="h-full" />
        </Reveal>
        <Reveal className="md:col-span-7" delay={0.15}>
          <ServiceCard service={SERVICES[3]} span="h-full" />
        </Reveal>
      </div>
    </div>
  </section>
);
